import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import ContactsList from './pages/ContactsList';
import AddContacts from './pages/AddContacts';

export default [
  {
    path: 'add',
    element: AddContacts,
  },
  { index: true, element: ContactsList },
] as Array<EnhancedRouteProps>;
